import React, { Fragment, useEffect, useState, useRef } from 'react';
import { translate } from '../Services/translation';
import { useSelector, useDispatch } from 'react-redux';
import { update as updateOrderRowQuantity } from '../Actions/Cart.action';
import { trackAddToCart } from '../Actions/HelloRetail.action';

const MiniCart = () => 
{
    const dispatch = useDispatch();
    const cart = useSelector((state) => state.cart);        
    let superBuilderParentOrderRows = (cart && cart.superBuilderParentOrderRows) || []; 
    let quantity = cart.quantity;   
    const [isOpen, setIsOpen] = useState(false);
    const cartRef = useRef(null);

    const configOrderRows = cart.orderRows.filter(function (row) {
        if (!row.comments) return true;
        var superBuilderBundleId = JSON.parse(row.comments).superBuilderBundleId;
        if (!superBuilderBundleId)
            return true;
    });

    let totalQuantity = configOrderRows.reduce(function (accumulator, item) {
        return accumulator + item.quantity;
    }, 0);
 
    useEffect(() => {
        let timer;
        if (cart.hintCart) {
            setIsOpen(true);

            timer = setTimeout(() => {
                setIsOpen(false);
            }, 3000);
        }

        return () => {
            if (timer) clearTimeout(timer);
        };
    }, [cart.hintCart]);
    
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (cartRef.current && !cartRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    useEffect(() => {
        if (sessionStorage.addedProducts && sessionStorage.addedProducts != quantity.toString()) {           
            const script = document.querySelector(`script[src='https://helloretailcdn.com/helloretail.js']`);
            if (script) {
                trackAddToCart(cart);
            }
            sessionStorage.addedProducts = quantity;
        }

        if (sessionStorage.addedProducts === undefined || sessionStorage.addedProducts === null) {
            sessionStorage.addedProducts = "0";
        }
    }, [quantity]);
        

    quantity = superBuilderParentOrderRows.length + totalQuantity;
    
    return (
        <div className="cart-hover-trigger" ref={cartRef}>
            <a href={cart.checkoutUrl} className="ti-menu-icon ti-menu-icon--cart ti-menu-icon--text">
                <span className="ti-menu-icon__title">{translate('minicart.checkout')}</span>
                <span className="cart-icon-container">
                    {quantity > 0 && <span className="cart-icon-container__indicator">
                        {quantity}
                    </span>}
                    <svg>
                        <use href="/ui/images/tibergs-svg/sprite/sprite.svg#cart"></use>
                    </svg>
                </span>
            </a>
            <div className={'mini-cart-content' + (isOpen ? ' mini-cart-content--hint' : '')}>
                <div className="mini-cart-content__container">
                    {quantity > 0 ? <Fragment>
                        <div className="mini-cart-content__title-container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h3 className="mini-cart-content__title">{translate('minicart.header')}</h3>
                            
                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                <a className="ti-btn" href={cart.checkoutUrl}>{translate('minicart.tocheckout')}</a>
                            </div>
                        </div>
                        <div className="mini-cart-content__items-container">
                            <div className="mini-cart-content__items">
                                {renderMiniCart(superBuilderParentOrderRows.length, superBuilderParentOrderRows, cart.checkoutUrl, isOpen, 
                                    cart.newlyAddedArticleNumber, true, dispatch, cart.includeVatCookie, cart.includeVATChannel)}
                                {renderMiniCart(configOrderRows.length, configOrderRows, cart.checkoutUrl, isOpen, cart.newlyAddedArticleNumber, 
                                    false, dispatch, cart.includeVatCookie, cart.includeVATChannel)}
                            </div>
                        </div>
                    </Fragment> : <div className="mini-cart-content__empty" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span>{translate('minicart.empty')}</span>
                        <button 
                            className="mini-cart-close-btn" 
                            onClick={() => setIsOpen(false)}
                            style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                        >
                            <svg style={{ width: '14px', height: '14px' }}>
                                <use href="/ui/images/tibergs-svg/sprite/sprite.svg#close"></use>
                            </svg>
                        </button>
                    </div>}
                </div>
            </div>
        </div>
    );
}

const renderMiniCart = (quantity, orderRows, checkoutUrl, hintCart, newlyAddedArticleNumber, isSuperBuilder, dispatch, includeVatCookie, includeVATChannel) => {
    let itemRows = [];

    function removeMiniOrderRow(superBuilderItems) {        
          return superBuilderItems.map(v => v.articleNumber);         
      }

    return orderRows && orderRows.length > 0 ? <ul>
        {orderRows.map((row, index) => {
            let itemRows = isSuperBuilder ? row.parentItem : row;
            return <li className={`mini-cart-item ${itemRows.articleNumber === newlyAddedArticleNumber ? "hint-item" : ""}`} key={`orderrow-${index}`}>
                <div className="mini-cart-item__img-column">
                    <img alt={itemRows.articleNumber} src={itemRows.image}></img>
                </div>
                <div className="mini-cart-item__info-column">
                    <span className="mini-cart-item__name">{itemRows.name}</span>                    
                    <span className="cart-remove-row mini-cart-item__remove-row" onClick={() => 
                        dispatch(updateOrderRowQuantity(isSuperBuilder ? removeMiniOrderRow(row.subVariants) : [itemRows.articleNumber], 0))}>
                        <svg>
                            <use href="/ui/images/tibergs-svg/sprite/sprite.svg#close"></use>
                        </svg>
                    </span>
                    <div className="mini-cart-item__content">
                        <div className="mini-cart-info">
                            <span className="mini-cart-info__title">{translate('minicart.myselection')}</span>
                            <ul className="mini-cart-info__list">
                                <li><span>{translate('minicart.quantity')}:</span> {itemRows.quantity}</li>
                                {itemRows.options.map((option, index) => {
                                    return <li key={`option-${index}`}>
                                        {option.name !== '' &&
                                            <span>{option.name}:</span>} {option.value}
                                    </li>
                                })}
                            </ul>
                        </div>
                        <div className="mini-cart-item__price-column">
                            <div className="mini-cart-prices">
                                <span className="mini-cart-prices__current">{itemRows.totalPrice}</span>                                
                                {(isSuperBuilder ? (itemRows.totalPriceValue !== itemRows.priceValue) : (itemRows.totalPriceValue !== itemRows.totalOrdinaryPriceValue)) &&
                                    <span className="mini-cart-prices__ordinary">{isSuperBuilder ? itemRows.price : itemRows.totalOrdinaryPrice}</span>
                                }
                                {!includeVATChannel && <span className='cart-price__exclvat'>{includeVatCookie ? translate("header.vattoggle.includingvat") 
                                : translate("header.vattoggle.excludingvat")}</span>}
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        })}
    </ul> : <></>
}

export default MiniCart;